import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=548046a1"
import script from "./Agency.vue?vue&type=script&lang=ts"
export * from "./Agency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports